import React, { useState, useEffect } from "react";

function ClientReviewRameshKNagarajan() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const reviews = [
    {
      name: "- vyshnavithotakura",
      location: "Montvale, NJ",
      contentHeading: "Happy with overall process ",
      content:
        "I recently had the pleasure of working with Ramesh to secure a mortgage for my home in New Jersey, and I couldn’t be happier with the experience! From start to finish, Ramesh made the process incredibly easy and smooth. He guided me through every step of the mortgage process, ensuring that I was always informed and confident in my decisions. His communication was excellent; I never felt left in the dark about what was happening. Ramesh’s honesty and transparency truly set him apart, making it clear that he had my best interests at heart.Thanks to Ramesh’s expertise and support, I was able to secure the mortgage I needed without any hassle. I highly recommend Ramesh to anyone looking for a reliable and knowledgeable mortgage specialist. His dedication to his clients is commendable, and I am very grateful for all his help!",
    },
    {
      name: "- pradeep paritala",
      location: "Fuquay Varina, NC",
      contentHeading:
        "Outstanding Support and Expertise for Home Loans and Refinancing! ",
      content:
        "I had an exceptional experience working with Ramesh as my home loan originator. He is incredibly honest, prompt, and transparent in every aspect of the process. Ramesh went above and beyond to ensure I got the best possible interest rate for both my first home purchase and a subsequent refinancing. As a first-time homebuyer, I had many questions, and Ramesh took the time to explain everything in great detail, making the entire process smooth and stress-free. Whether you're buying your first home or refinancing, Ramesh's expertise and commitment make him an excellent choice. I’m truly grateful for his guidance and support throughout my journey.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [reviews.length]);

  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % reviews.length);
  };

  const handlePrev = () => {
    setCurrentIndex((currentIndex - 1 + reviews.length) % reviews.length);
  };

  return (
    <div className="OurSatisfiedBoxParent">
      <div className="OurSatisfiedBox">
        {reviews.map((review, index) => (
          <div
            className={`OurSatisfiedContentBox ${
              index === currentIndex ? "active" : "inactive"
            }`}
            key={index}
          >
            <span className="OurSatisfiedStars">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
            </span>
            <span className="OurSatisfiedContent">
              <span className="OurSatisfiedName">{review.contentHeading}</span>
              {review.content}
            </span>
            <span className="OurSatisfiedNameLocation">
              <span className="OurSatisfiedName">{review.name}</span>
              <span className="OurSatisfiedLocation">{review.location}</span>
            </span>
          </div>
        ))}
      </div>
      <span className="OurSatisfiedArrows">
        <i
          className="ri-arrow-left-wide-fill OurSatisfiedLeftArrow"
          onClick={handlePrev}
        ></i>
        <i
          className="ri-arrow-right-wide-fill OurSatisfiedRightArrow"
          onClick={handleNext}
        ></i>
      </span>
    </div>
  );
}

export default ClientReviewRameshKNagarajan;
